export const COMPONENT_NAME = "shared-currency";
